import l10n from '../../lang/locallang';

export default class RunTutorialCustomVideo {
    vsPopupInit = new vsPopupClass();
    constructor() {
        this.eventListeners();
    }

    eventListeners() {
        window.addEventListener('click', (e) => {
            this.onClickEvents(e);
        });
    };

    onClickEvents(e) {
        if (e.target.closest('.open-video-popup')) {
            e.preventDefault();
            if(e.target.closest('.open-video-popup').dataset.url.indexOf('https://') === 0){
                this.openVideoPopup(e.target.closest('.open-video-popup'), true);
                return;
            }
            this.openVideoPopup(e.target.closest('.open-video-popup'));
        }
    }

    //request to S3 to get the video url
     getVideoUrl(videoURL) {
        const url = getCloudFrontContentURL;
        const data = {
            path: videoURL,
            isCustomContent: true,
        };
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, false);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify(data));
        if (xhr.status === 200) {
            const response = JSON.parse(xhr.responseText);
            if (response) {
                return response.url;
            }
        }
        return '';
    }

    openVideoPopup(button, afterLoading = false) {
        let videoPopup = document.getElementById('video-popup');
        let videoUrl = button.dataset.url;
        if(!afterLoading){
            videoUrl = this.getVideoUrl(button.dataset.url);
        }

        if(!videoUrl){
            return;
        }
        if(!videoPopup){
            videoPopup = document.createElement('div');
            videoPopup.classList.add('video-popup', 'vs-popup');
            videoPopup.setAttribute('id', 'video-popup');
            videoPopup.innerHTML = `<a href="#" class="popup-close popup-close-icon"><i class="icon icon-close-white"></i></a>
            <div class="video-popup__content">
                <div class="video-popup__video">
                    <video src="${videoUrl}" controls="controls" autoplay></video>
                </div>
            </div>`;
            //<iframe src="${videoUrl}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            document.body.appendChild(videoPopup);
        }
        setTimeout((e) => {
            this.vsPopupInit.open('video-popup');
        }, 200);
        this.videoPopupCloseEvent();
        //run after video ended
        const video = videoPopup.querySelector('video');
        if(video){
            video.addEventListener('ended', (e) => {
                this.vsPopupInit.close('video-popup');
                this.updateTopicStatus(button.id, 5);
                this.runPostAssessment(button.id.replace('tutorial_', ''));
            });
        }
    }

    runPostAssessment(topic_id) {
        const { notStarted } = l10n.textTopicResultNotification;
        //get the post assessment url
        let html = `<i class="bullet __gray"></i>
            <a href="#" class="open-multiple-choice take-assessment" data-pre="post" data-type="2" data-lesson="${topic_id}">${notStarted}</a>`;
        // get element by 2 data attributes data-pre and data-lesson
        let element = document.querySelector(`[data-pre="post"][data-lesson="${topic_id}"]`);
        if (element) {
            let box = element.closest('.el-pre-post');
            box.innerHTML = html;
            setTimeout((e) => {
                box.querySelector('a').click();
            }, 200);
        }
    }

    updateTopicStatus(topic_id, status) {
        const { complete } = l10n.textTopicResultNotification;
        let lessonElement = document.getElementById(topic_id);
        let module = lessonElement.closest('.course-progress-table');
        let data = {
            status: status,
            topic_id: topic_id,
            learning_mode_id: module.querySelector('thead').id,
            learnerId: lmsUserId,
            courseId: courseId
        };
        fetch(saveStatusUrl, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                if(status === 5){
                    //update the status of the topic
                    let tutorial = document.getElementById(topic_id);
                    if(tutorial){
                        tutorial.innerHTML = `<i class="bullet __green"></i><span>${complete}</span>`;
                    }
                }
            });
    }

    videoPopupCloseEvent() {
        const videoPopup = document.getElementById('video-popup');
        if (videoPopup) {
            document.addEventListener('vsPopupAfterClose', (e) => {
                if(e.detail.popup){
                    if (e.detail.popup.id === 'video-popup') {
                        videoPopup.remove();
                    }
                }
            });
        }
    }
}
